import {
    FORGOT_PASSWORD,
    FORGOT_PASSWORD_FAIL,
    FORGOT_PASSWORD_SUCCESS
} from './actionTypes';

const initialState = {
    email: null,
    resetEmailSent: false,
    error: null
};

export function forgotPasswordReducer(state = initialState, action) {
    switch (action.type) {
        case FORGOT_PASSWORD: {
            const { email } = action.payload;
            return {
                ...initialState,
                email
            }
        }
        case FORGOT_PASSWORD_SUCCESS: {
            return {
                ...state,
                resetEmailSent: true
            };
        }
        case FORGOT_PASSWORD_FAIL: {
            return {
                ...state,
                error: action.payload
            };
        }
        default:
            return state;
    }
}
